import React from 'react';
import { Route } from 'react-router-dom';
import DashboardIcon from "@mui/icons-material/Dashboard";
import { RoutePathProps } from '../../../AppRoutes/types';

const DashboardPage = React.lazy(() => import('../pages/DashboardPage'));

const dashboard: RoutePathProps = {
  name: "dashboard",
  path: "/",
  label: "Dashboard",
  icon: DashboardIcon,
  visibleInNav: true,
  requiredPermission:'dashboard:view'
};

const DashboardRoutes = (
	<>
		<Route path={dashboard.path} element={<DashboardPage />} />
	</>
);

export const dashboardPaths = [dashboard];
export default DashboardRoutes;
